import * as React from 'react';
import { FC, useEffect } from 'react';
import NameFilter from './NameFilter';
import ProviderFilter from './ProviderFilter';
import { CasinoFiltersProps } from './types';
import useCasinoFilters from './useCasinoFilters';

const CasinoFilters: FC<CasinoFiltersProps> = (props) => {
  const { filters, setFilter } = useCasinoFilters(props.filters);

  useEffect(() => {
    const element = document.querySelector('[data-filters-loaded="false"]');
    if (element) element.setAttribute('data-filters-loaded', 'true');
  }, []);

  return (
    <div className="casino-filters">
      <NameFilter value={filters.name} onChange={(v) => setFilter('name', v)} locales={props.locales} />
      <ProviderFilter
        value={filters.provider}
        onChange={(v) => setFilter('provider', v)}
        locales={props.locales}
        providerInfos={props.providers}
      />
    </div>
  );
};

export default CasinoFilters;
